export default {
  'nav.poti': 'Маршруты',
  'nav.izhodisca': 'Точки старта',
  'nav.galerija': 'Галерея',
  'nav.vreme': 'Погода',
  'nav.o_nas': 'О нас',
  'nav.zacni_pot': 'Начать маршрут',
  'nav.odpri_meni': 'Открыть меню',
  'nav.zapri_meni': 'Закрыть меню',
  'nav.preskoci': 'Перейти к содержанию',

  'hero.badge': 'Туристическое общество STEZA — Шмарна Гора',
  'hero.title': 'ТРОПА НА ПЕСКЕ',
  'hero.subtitle': 'ШМАРНА ГОРА',
  'hero.desc': 'Один из самых красивых, разнообразных и доступных маршрутов для посетителей всех поколений.',
  'hero.cta_start': 'Начать маршрут',
  'hero.cta_explore': 'Исследовать маршруты',
  'hero.cta_activities': 'Активности',
  'hero.scroll': 'Прокрутить вниз',

  'intro.badge': 'Добро пожаловать',
  'intro.title': 'Шмарна Гора — самый любимый холм Любляны',
  'intro.desc': 'Шмарна Гора, самый популярный холм близ Любляны, предлагает множество троп для пеших туристов, бегунов и любителей природы.',
  'intro.highlight': 'Тропа Песке считается одним из самых красивых, разнообразных и доступных маршрутов для посетителей всех возрастов.',
  'intro.pot_label': 'Тропа Песке',
  'intro.route': 'Сподне Пирниче → Шмарна Гора',

  'activities.badge': 'Активности',
  'activities.title': 'ИССЛЕДОВАНИЕ ШМАРНОЙ ГОРЫ',
  'activities.hiking.title': 'Пешие походы на Шмарну Гору',
  'activities.hiking.desc': 'Откройте для себя разнообразные маршруты — от лёгких прогулок до более сложных восхождений.',
  'activities.cycling.title': 'Велоспорт вокруг Шмарной Горы',
  'activities.cycling.desc': 'Исследуйте живописные веломаршруты в окрестностях с прекрасными видами.',
  'activities.running.title': 'Трейлраннинг на Шмарной Горе',
  'activities.running.desc': 'Популярное направление для трейлраннеров — разнообразный рельеф с идеальным уклоном.',
  'activities.running_around.title': 'Бег вокруг Шмарной Горы',
  'activities.running_around.desc': 'Ровные и пологие беговые петли у подножия, идеально подходящие для оздоровительных тренировок.',
  'activities.walks.title': 'Прогулки у подножия Шмарной Горы',
  'activities.walks.desc': 'Спокойные прогулки по лугам и лесным тропам, идеально для семей.',

  'access.badge': 'Точка старта',
  'access.title': 'ТОЧКА СТАРТА И ДОСТУП',
  'access.desc': 'Маршрут начинается у парковки LIPA в Сподне Пирниче. Добраться просто — на автомобиле или автобусе.',
  'access.start_label': 'Начало маршрута',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'Парковка LIPA',
  'access.parking': 'Парковка',
  'access.free': 'Бесплатно',
  'access.bus': 'Автобус',
  'access.bus_line': 'Линия 25',
  'access.info1': 'Припаркуйте автомобиль на парковке LIPA или приезжайте на автобусе №25 прямо к точке старта, перед рестораном с прекрасной террасой, где вы можете насладиться освежающим напитком или закуской перед началом похода.',
  'access.info2': 'В начале узкая тропинка, усыпанная древесной щепой, ведёт вас мимо луга к лесу, где начинается подъём.',

  // ── PARKING ──
  'parking.hero_title': 'Парковка LIPA — Официальный старт',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Любляна-Шмартно. Бесплатная парковка прямо у начала тропы Pot na Peske.',
  'parking.highlight_badge': '⭐ Официальный старт',
  'parking.section_title': 'ПАРКОВКА И ДОСТУП',
  'parking.intro': 'Парковка LIPA — официальный, бесплатный и самый удобный старт для Pot na Peske — нашего самого красивого маршрута на Шмарну гору.',
  'parking.address_label': 'Адрес',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Любляна-Шмартно, Словения',
  'parking.gps_label': 'GPS координаты',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Вместимость',
  'parking.capacity_value': 'Бесплатно, мест для 20+ автомобилей',
  'parking.type_label': 'Тип парковки',
  'parking.type_value': 'Открытая гравийная парковка',
  'parking.hours_label': 'Открыто',
  'parking.hours_value': '24/7 — круглый год',
  'parking.bus_info_title': 'Общественный транспорт',
  'parking.bus_info': 'Автобус LPP линии 25 идёт прямо до остановки перед парковкой. Поездка из центра Любляны занимает около 30 минут.',
  'parking.facilities_title': 'Инфраструктура',
  'parking.facility_gostilna': 'Ресторан с прекрасной террасой прямо у парковки',
  'parking.facility_wc': 'Туалет доступен в ресторане',
  'parking.facility_info': 'Информационный щит в начале тропы Pot na Peske',
  'parking.facility_sign': 'Указатель STEZA / Pot na Peske',
  'parking.tips_title': 'Советы по парковке',
  'parking.tip1': 'В выходные и праздники парковка быстро заполняется — приезжайте пораньше (до 8 утра).',
  'parking.tip2': 'Парковка гравийная — зимой будьте внимательны к возможному гололёду.',
  'parking.tip3': 'Не оставляйте ценные вещи в автомобиле. Паркуйтесь на свой страх и риск.',
  'parking.tip4': 'Дополнительная парковка у Gostilna Ledinek в Тацене (5 мин езды), если LIPA заполнена.',
  'parking.map_title': 'Расположение на карте',
  'parking.cta_title': 'Готовы к Pot na Peske?',
  'parking.cta_subtitle': 'Паркуйтесь на LIPA и отправляйтесь по самому красивому маршруту на Шмарну гору.',
  'parking.cta_btn': 'Начать маршрут',
  'parking.cta_routes': 'Все маршруты',

  'story.badge': 'Тропа Песке',
  'story.title': 'ОТ СТАРТА ДО ВЕРШИНЫ',
  'story.subtitle': 'Кинематографическое путешествие по каждому этапу маршрута',
  'story.etapa': 'Этап',
  'story.blocks.0.title': 'Пологий старт',
  'story.blocks.0.text': 'Сначала мы плавно поднимаемся по удобной, широкой тропе, частично покрытой камнями и корнями. Вскоре сворачиваем на всё более узкую тропу, которая поднимается немного круче.',
  'story.blocks.0.terrain': 'Широкая тропа, камни, корни',
  'story.blocks.1.title': 'Самый разнообразный участок',
  'story.blocks.1.text': 'Мы идём по всё более песчаной почве, по камням и корням, частично через довольно глубокий овраг. Это самый крутой, но и самый разнообразный участок маршрута.',
  'story.blocks.1.terrain': 'Песчаная почва, камни, овраг',
  'story.blocks.2.title': 'Гравийная дорога',
  'story.blocks.2.text': 'Когда тропа расширяется и выравнивается, мы вскоре выходим на широкую гравийную дорогу — автомобильный путь на Шмарну Гору из Заврха.',
  'story.blocks.2.terrain': 'Гравий, широкая дорога',
  'story.blocks.3.title': 'Турецкий памятник',
  'story.blocks.3.text': 'Здесь указатель направляет нас направо, мимо Чумного, или Турецкого памятника, напоминающего о временах османских набегов.',
  'story.blocks.3.terrain': 'Указатель, историческая точка',
  'story.blocks.4.title': 'Часовня Горьянц',
  'story.blocks.4.text': 'Дорога плавно поднимается через лес, который постепенно раскрывается. Слева — часовня Горьянц, где сохранился обычай оставлять маленькие кресты.',
  'story.blocks.4.terrain': 'Лесная дорога, часовня',
  'story.blocks.5.title': 'Сподни Горьянц — перекрёсток',
  'story.blocks.5.text': 'Мы доходим до Сподни Горьянц — важного перекрёстка нескольких троп. Здесь пересекаются направления на Грмаду, Тропу корней (к Тацену) и продолжение к Шмарной Горе.',
  'story.blocks.5.terrain': 'Перекрёсток троп, Грмада, Тропа корней',
  'story.blocks.6.title': 'Вид на Альпы',
  'story.blocks.6.text': 'Продолжаем путь через пастбищные луга, где открываются виды на Камницко-Савиньские Альпы и Юлийские Альпы с Триглавом.',
  'story.blocks.6.terrain': 'Пастбищные луга, панорамные виды',
  'story.blocks.7.title': 'Седло — перекрёсток с Грмадой',
  'story.blocks.7.text': 'На Седле (седловине) тропа пересекается с маршрутом на Грмаду и соединяется с тропами из Тацена, Шмартного и Викрч. Отсюда можно выбрать более лёгкий гравийный путь или более узкую, каменистую тропу мимо часовни св. Соботы.',
  'story.blocks.7.terrain': 'Седловина, перекрёсток Грмада–Шмарна Гора, два варианта',
  'story.blocks.8.title': 'Вершина — выбор пути',
  'story.blocks.8.text': 'Рекомендуется подъём по более сложной тропе и спуск по более пологой. Так вы испытаете обе стороны Шмарной Горы и получите полное впечатление.',
  'story.blocks.8.terrain': 'Две тропы, подъём и спуск',

  'highlight.title': 'Одна из самых доступных троп на Шмарной Горе',
  'highlight.text1': 'Это также одна из самых доступных троп на Шмарной Горе — никогда не открытая, без крутых участков, и приятная для ходьбы даже после дождя, когда многие другие тропы грязные.',
  'highlight.text2': 'Первый участок очень разнообразен и поэтому чрезвычайно популярен среди пеших туристов, бегунов и семей.',

  'viewpoint.badge': 'Панорама',
  'viewpoint.title': 'ВИДЫ С ВЕРШИНЫ',
  'viewpoint.desc': 'На вершине Шмарной Горы в ясные дни уделите время, чтобы насладиться великолепными видами на Любляну, реку Саву, окрестные холмы и Альпы. Вершина с живописной церковью предлагает одну из лучших панорам центральной Словении.',

  'gallery.badge': 'Галерея',
  'gallery.title': 'Шмарна Гора через объектив',
  'gallery.subtitle': 'Моменты, оживляющие дух горы — каждая фотография рассказывает свою историю',
  'gallery.enlarge': 'Увеличить',
  'gallery.close': 'Закрыть предпросмотр',
  'gallery.prev': 'Предыдущее изображение',
  'gallery.next': 'Следующее изображение',
  'gallery.open': 'Открыть изображение',

  'weather.badge': 'Погода онлайн',
  'weather.title': 'ПОГОДА НА ШМАРНОЙ ГОРЕ',
  'weather.loading': 'Обновление...',
  'weather.updated': 'Последнее обновление',
  'weather.current': 'Сейчас',
  'weather.feels_like': 'Ощущается',
  'weather.wind': 'Ветер',
  'weather.humidity': 'Влажность',
  'weather.visibility': 'Видимость',
  'weather.cloud_cover': 'Облачность',
  'weather.uv_index': 'УФ-индекс',
  'weather.rain': 'Дождь',
  'weather.hiking_score': 'Оценка для похода',
  'weather.out_of': 'из 100 баллов',
  'weather.trail_safety': 'Безопасность тропы',
  'weather.safety_optimal': 'Безопасные условия',
  'weather.safety_caution': 'Требуется осторожность',
  'weather.safety_warning': 'Сложные условия',
  'weather.safety_danger': 'Опасные условия',
  'weather.no_alerts': 'Особых предупреждений нет',
  'weather.best_time': 'Лучшее время для похода',
  'weather.next_hours': 'Ближайшие часы',
  'weather.seven_day': 'Прогноз на 7 дней',
  'weather.disclaimer': 'Данные носят информационный характер. Перед походом всегда проверяйте официальный прогноз погоды. Источник: Open-Meteo API.',
  'weather.error_load': 'Не удалось загрузить данные о погоде',
  'weather.error_stale': 'Показаны последние сохранённые данные',
  'weather.smarna_elevation': 'Шмарна Гора, 669м',

  'safety.badge': 'Важно',
  'safety.title': 'БЕЗОПАСНОСТЬ НА ТРОПЕ',
  'safety.slippery_title': 'Скользкая поверхность',
  'safety.slippery_desc': 'После дождя корни и камни становятся чрезвычайно скользкими. Надевайте походную обувь с хорошим сцеплением. Избегайте коротких путей по мокрой местности.',
  'safety.winter_title': 'Зимние условия',
  'safety.winter_desc': 'Зимой тропы могут быть обледенелыми. Обязательно зимнее снаряжение: кошки, треккинговые палки. Проверьте погоду перед выходом.',
  'safety.sunset_title': 'Восход / закат',
  'safety.sunset_desc': 'Если вы отправляетесь на восход или закат, обязательно возьмите налобный фонарь. Всегда сообщайте кому-нибудь о своём маршруте.',
  'safety.emergency_title': 'Экстренная помощь',
  'safety.emergency_desc': 'В экстренных случаях звоните 112. Приложение Горной спасательной службы позволяет быстро определить местоположение. Сохраните номер перед походом.',
  'safety.warning_title': 'ПРЕДУПРЕЖДЕНИЕ',
  'safety.warning_text': 'Информация на этой странице носит ознакомительный характер. Походы осуществляются на свой страх и риск. Перед каждым походом проверяйте погодные условия, обеспечивайте соответствующее снаряжение и оценивайте свою физическую подготовку. STEZA не несёт ответственности за возможные травмы или несчастные случаи.',

  'facebook.badge': 'Сообщество',
  'facebook.title': 'ПРИСОЕДИНЯЙТЕСЬ К НАМ',
  'facebook.desc': 'Следите за STEZA.SI на Facebook — свежие новости, события и фотографии',
  'facebook.label': 'Facebook сообщество',

  'webcam.badge': 'Онлайн',
  'webcam.title': 'ВЕБ-КАМЕРА ШМАРНОЙ ГОРЫ',
  'webcam.desc': 'Прямой вид с вершины Шмарной Горы — скоро будет доступен',
  'webcam.coming_soon': 'Веб-камера скоро будет доступна',
  'webcam.preparing': 'Мы готовим прямую трансляцию с вершины Шмарной Горы. Спасибо за ваше терпение.',
  'webcam.status': 'В подготовке',

  'media.badge': 'Медиа',
  'media.title': 'ГАЛЕРЕЯ И ВИДЕО',
  'media.desc': 'Кинематографические съёмки и фотографии Шмарной Горы — скоро будут доступны',
  'media.drone': 'ВИДЕО С ДРОНА В ПРОИЗВОДСТВЕ',
  'media.drone_desc': 'Кинематографическая съёмка Тропы Песке',
  'media.views': 'Виды',
  'media.trail': 'Тропа',
  'media.history': 'История',

  'footer.desc': 'Тропа Песке — Шмарна Гора. Туристическое общество STEZA. Премиальный опыт пеших походов с профессиональной информацией о маршрутах, погоде и безопасности.',
  'footer.newsletter_title': 'Получайте новости о маршрутах',
  'footer.newsletter_success': 'Спасибо! Вы подписаны на новости STEZA.',
  'footer.newsletter_placeholder': 'Введите ваш email',
  'footer.newsletter_btn': 'Подписаться',
  'footer.trails': 'Маршруты',
  'footer.platform': 'Платформа',
  'footer.legal': 'Правовая информация',
  'footer.pot_peske': 'Тропа Песке',
  'footer.pot_korenine': 'Тропа корней',
  'footer.mazijeva': 'Тропа Мази',
  'footer.romarska': 'Паломническая тропа',
  'footer.plezalna': 'Скалолазный маршрут',
  'footer.izhodisca': 'Точки старта',
  'footer.galerija': 'Галерея',
  'footer.vreme': 'Погода',
  'footer.o_stezi': 'О STEZA',
  'footer.kontakt': 'Контакты',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.cookies': 'Cookie',
  'footer.disclaimer': 'Отказ от ответственности',
  'footer.safety_notice': 'Уведомление о безопасности',
  'footer.copyright': '© 2026 STEZA.SI — Туристическое общество STEZA, Шмарна Гора',
  'footer.disclaimer_text': 'Важное примечание: Информация на сайте носит ознакомительный характер. Походы и активный отдых осуществляются на свой страх и риск. Перед посещением проверьте погодные условия, соответствующее снаряжение и состояние троп.',
  'footer.facebook_label': 'STEZA на Facebook',
  'footer.instagram_label': 'STEZA в Instagram',

  'about.hero_title': 'О STEZA',
  'about.hero_subtitle': 'Премиальная платформа для пеших походов, созданная с любовью к Шмарной Горе.',
  'about.story_badge': 'Наша история',
  'about.story_title': 'Самая красивая тропа на Шмарной Горе',
  'about.story_p1': 'STEZA родилась из простой идеи: поход на Шмарну Гору может быть больше, чем просто отдых — он может быть опытом. Мы создали платформу, которая объединяет профессиональную информацию для походов с выдающейся эстетикой и современными технологиями.',
  'about.story_p2': 'Мы — команда пеших туристов, фотографов и дизайнеров, которые верят, что каждая гора заслуживает своей премиальной презентации. Шмарна Гора — это не просто холм, это символ Любляны, место паломничества, природная жемчужина и спортивная арена в одном.',
  'about.story_p3': 'STEZA — не туристический портал. Не блог. Это премиальная кинематографическая платформа для походов для всех, кто хочет открыть Шмарну Гору по-новому.',
  'about.elevation_label': 'Шмарна Гора',
  'about.elevation': '669 м над уровнем моря',
  'about.how_title': 'Как создавалась STEZA',
  'about.how_p1': 'История началась на вершине Шмарной Горы. Мы стояли на смотровой площадке, смотрели на Альпы и спрашивали себя: почему у такого прекрасного холма нет современного, понятного и красивого представления в интернете? Всё, что мы нашли — разрозненные сообщения на форумах, устаревшие блоги и фотографии низкого качества. И тогда мы решили — мы создадим нечто иное.',
  'about.how_p2': 'Последующие шесть месяцев мы провели в поле. Мы прошли каждую тропу — от самой лёгкой до самой сложной. Мы фотографировали рассветы, дождливые леса, заснеженные вершины и золотые закаты. Мы разговаривали с местными гидами, владельцами гостиниц, опытными туристами и новичками. Мы хотели понять Шмарну Гору с каждого ракурса.',
  'about.how_p3': 'STEZA — не просто веб-сайт. Это визуальный дневник нашей любви к этой горе. Каждая фотография сделана профессионально, каждая тропа пройдена лично, каждый факт проверен. Мы верим, что Шмарна Гора — как одна из самых посещаемых туристических точек Словении — заслуживает презентации мирового уровня.',
  'about.how_p4': 'Вдохновение для дизайна мы черпали из премиальных брендов outdoor, таких как Patagonia, The North Face и National Geographic Travel. Мы хотели создать платформу, которая дышит приключениями, оставаясь при этом минималистичной, чистой и профессиональной.',
  'about.how_p5': 'Сегодня STEZA охватывает четыре основных маршрута на Шмарну Гору, живые данные о погоде, GPS-навигацию, руководства по безопасности и богатую галерею. Но это только начало. Наше видение — стать лучшей платформой для походов в Словении, и Шмарна Гора — наш первый, самый любимый проект.',
  'about.gora_badge': 'Познакомьтесь с горой',
  'about.gora_title': 'Шмарна Гора — сердце нашей истории',
  'about.gora_subtitle': '669 метров, объединяющих поколения',
  'about.gora_p1': 'Шмарна Гора (669 м) — самая популярная вершина для прогулок в центральной Словении. Она находится всего в 10 километрах к северо-западу от Любляны, но, несмотря на близость к городу, предлагает подлинный контакт с природой, богатую историю и захватывающие виды.',
  'about.gora_p2': 'Это инзельберг — холм, который геологически не относится ни к одной крупной горной цепи, а самостоятельно возвышается над Люблянской котловиной. Он состоит из известняка и доломита, а его южные склоны известны теплолюбивыми видами растений.',
  'about.gora_p3': 'На протяжении веков Шмарна Гора была всем: доисторическим поселением, стратегической точкой с замком Шумберк, местом паломничества, популярным местом отдыха горожан, и сегодня она является неотъемлемой частью спортивной и культурной идентичности Любляны.',
  'about.history_title': 'История, высеченная в камне',
  'about.history_bronze_date': '1500 г. до н.э.',
  'about.history_bronze_title': 'Бронзовый век',
  'about.history_bronze_text': 'Археологические находки на вершине свидетельствуют о доисторическом поселении. Керамика, орудия труда и остатки жилищ указывают на постоянное заселение в бронзовом веке.',
  'about.history_castle_date': 'XII–XIII вв.',
  'about.history_castle_title': 'Замок Шумберк',
  'about.history_castle_text': 'На вершине стоял средневековый замок Шумберк (Schönberg). Сегодня от него остались лишь скромные археологические следы и легенды о рыцарях.',
  'about.history_church_date': '1711 г.',
  'about.history_church_title': 'Церковь Божьей Матери',
  'about.history_church_text': 'На месте более ранней готической церкви XIV века была построена барочная церковь. Она стала центральным местом паломничества центральной Словении.',
  'about.history_modern_date': 'XIX в.–сегодня',
  'about.history_modern_title': 'Альпийское направление',
  'about.history_modern_text': 'С развитием альпинизма стала самым популярным местом отдыха жителей Любляны. Сохраняет этот статус и сегодня с более чем 500 000 посетителей ежегодно.',
  'about.nature_title': 'Природа, которая вдохновляет',
  'about.nature_p1': 'Южные склоны Шмарной Горы — ботанический рай. Тёплый микроклимат используют растения, которые обычно встречаются значительно южнее: морозник чёрный цветёт уже в феврале, за ним следуют ирис душистый, прострел обыкновенный и безвременник осенний.',
  'about.nature_p2': 'Леса смешанные — преобладают бук, дуб и ель, а на вершине растёт могучий каштан. Животный мир включает косуль, лисиц, диких кабанов, барсуков, белок и сонь.',
  'about.nature_p3': 'Мы поощряем ответственный туризм — не оставляйте следов, не срывайте растения, не беспокойте животных и уносите мусор с собой в долину.',
  'about.legends_title': 'Легенды, которые живут',
  'about.legend_bell_title': 'Колокол желаний',
  'about.legend_bell_text': 'Самая известная легенда Шмарной Горы. Если трижды позвонить в колокол — первый раз за здоровье, второй раз за удачу и третий раз за любовь — и при каждом звоне загадать желание, оно обязательно сбудется.',
  'about.legend_castle_title': 'Замок Шумберк и сокровище',
  'about.legend_castle_text': 'Легенда гласит, что рыцари замка Шумберк перед уходом в крестовые походы закопали золотое сокровище где-то на склонах Шмарной Горы. Никто так и не нашёл его.',
  'about.legend_mary_title': 'Явление Девы Марии',
  'about.legend_mary_text': 'Согласно народному преданию, на вершине холма явилась Дева Мария, благодаря чему гора получила своё имя. Это предание привело к строительству церкви и паломнической традиции, длящейся более 300 лет.',
  'about.stats_title': 'STEZA в цифрах',
  'about.values_title': 'Наши ценности',
  'about.values.professionalism': 'Профессионализм',
  'about.values.professionalism_text': 'Вся информация тщательно проверяется и регулярно обновляется. Мы сотрудничаем с местными гидами и Горной спасательной службой.',
  'about.values.aesthetics': 'Эстетика',
  'about.values.aesthetics_text': 'Мы верим, что красивые визуальные элементы — ключ к вдохновению. Каждая фотография на сайте профессионально снята и курирована.',
  'about.values.safety': 'Безопасность',
  'about.values.safety_text': 'Безопасность на первом месте. Каждый маршрут включает подробные предупреждения, рекомендованное снаряжение и руководства по безопасности.',
  'about.values.passion': 'Страсть',
  'about.values.passion_text': 'STEZA — проект, рождённый из страсти. Каждый член команды — пеший турист, который лично знает каждую тропу на Шмарной Горе.',
  'about.values.sustainability': 'Устойчивость',
  'about.values.sustainability_text': 'Мы продвигаем ответственный туризм. Не оставляйте следов, уважайте природу и диких животных, уносите мусор с собой.',
  'about.values.community': 'Сообщество',
  'about.values.community_text': 'Мы строим сообщество пеших туристов, которые делятся опытом и помогают друг другу открывать Шмарну Гору.',
  'about.cta_title': 'Присоединяйтесь к STEZA',
  'about.cta_subtitle': 'У каждой тропы есть история. Откройте её вместе с нами.',
  'about.cta_explore': 'Исследовать маршруты',
  'about.cta_contact': 'Связаться с нами',

  'contact.hero_title': 'Контакты',
  'contact.hero_subtitle': 'У вас есть вопрос, предложение или вы хотите сотрудничать? Напишите или позвоните нам.',
  'contact.write_us': 'Напишите нам',
  'contact.email_label': 'Электронная почта',
  'contact.phone_label': 'Телефон',
  'contact.location_label': 'Местоположение',
  'contact.location_value': 'Шмарна Гора, 1211 Любляна-Шмартно, Словения',
  'contact.follow_us': 'Подписывайтесь на нас',
  'contact.success_title': 'Спасибо за сообщение!',
  'contact.success_text': 'Мы ответим вам как можно скорее.',
  'contact.name_label': 'Имя',
  'contact.name_placeholder': 'Ваше имя',
  'contact.email_placeholder': 'vasha@pochta.ru',
  'contact.message_label': 'Сообщение',
  'contact.message_placeholder': 'Ваше сообщение (макс. 500 знаков)',
  'contact.submit': 'Отправить сообщение',
  'contact.error_fields': 'Пожалуйста, заполните все поля.',
  'contact.error_length': 'Сообщение слишком длинное. Максимум 500 знаков.',
  'contact.error_general': 'Произошла ошибка. Попробуйте ещё раз.',

  'routes.hero_title': 'Маршруты',
  'routes.hero_subtitle': 'Пять уникальных маршрутов на вершину Шмарной Горы. От лёгкой Тропы Песке до сложных скалолазных трасс — выберите свою STEZA.',
  'routes.explore': 'Исследовать маршрут',
  'routes.compare_title': 'Сравнение маршрутов',
  'routes.table_pot': 'Маршрут',
  'routes.table_tezavnost': 'Сложность',
  'routes.table_trajanje': 'Длительность',
  'routes.table_visinska': 'Набор высоты',
  'routes.table_dolzina': 'Протяжённость',
  'routes.table_tip': 'Тип',
  'routes.cta_title': 'Готовы к своей STEZA?',
  'routes.cta_subtitle': 'Выберите маршрут, который подходит вам лучше всего, и откройте Шмарну Гору так, как запомните навсегда.',
  'routes.cta_find': 'Найти точку старта',
  'routes.cta_weather': 'Проверить погоду',
  'routes.difficulty_easy': 'Лёгкий',
  'routes.difficulty_moderate': 'Средний',
  'routes.difficulty_hard': 'Сложный',

  'gallery_page.badge': 'Фотографическая коллекция',
  'gallery_page.title': 'Галерея',
  'gallery_page.subtitle': 'Коллекция фотографий Шмарной Горы — тропы, виды и моменты, которыми мы делимся.',
  'gallery_page.section_trail_title': 'Путь к вершине',
  'gallery_page.section_trail_subtitle': 'Пешеходные тропы через лес и природу во время подъёма',
  'gallery_page.section_summit_title': 'Вершина',
  'gallery_page.section_summit_subtitle': 'Виды, панорама и моменты на вершине Шмарной Горы',
  'gallery_page.section_parking_title': 'Парковка',
  'gallery_page.section_parking_subtitle': 'Доступ к точке старта и парковка во все сезоны',
  'gallery_page.empty_title': 'Раздел {title} готов. Добавьте изображения, и они появятся здесь.',
  'gallery_page.empty_subtitle': 'Раздел готов.',
  'gallery_page.close': 'Закрыть галерею',
  'gallery_page.prev': 'Предыдущее изображение',
  'gallery_page.next': 'Следующее изображение',
  'gallery_page.open': 'Просмотр изображения',
  'gallery_page.cta_title': 'Сделайте свою фотографию',
  'gallery_page.cta_subtitle': 'Самые красивые фотографии рождаются на вершине. Делитесь лучшими снимками с хэштегом #STEZA.',
  'gallery_page.cta_btn': 'Найти свою тропу',

  'legal.not_found': 'Страница не найдена',
  'legal.back_home': '← На главную',
  'legal.updated': 'Последнее обновление',
  'legal.copyright': '© 2026 STEZA.SI — Все права защищены. Контакт: info@steza.si',

  'notfound.title': 'Эта страница ещё не создана',
  'notfound.subtitle': 'Расскажите мне больше об этой странице, чтобы я мог её создать',
  'notfound.back_home': 'Вернуться на главную',

  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  'seo.home_title': 'Тропа Песке — Шмарна Гора | STEZA — Премиальная платформа для походов',
  'seo.home_desc': 'Тропа Песке — один из самых красивых маршрутов на Шмарну Гору. Премиальный опыт походов с профессиональной информацией о маршрутах, погоде, безопасности и смотровых точках. Туристическое общество STEZA.',
  'seo.home_keywords': 'Тропа Песке, Шмарна Гора, поход на Шмарну Гору, походы Словения, маршруты Шмарна Гора, походы Любляна, альпинизм Словения',
  'seo.og_title': 'Тропа Песке — Шмарна Гора | STEZA',
  'seo.og_desc': 'Премиальная платформа для походов на Шмарну Гору. Откройте Тропу Песке — один из самых красивых и доступных маршрутов на Шмарну Гору.',
  'seo.schema_desc': 'Тропа Песке — один из самых красивых маршрутов на Шмарну Гору. Туристическое общество STEZA — премиальная платформа для походов на Шмарну Гору.',
};